import React, { useState } from 'react';
import styled from 'styled-components'

const ResultsCategories = ({ categories, searchCategory, input, data }: { categories: any[], searchCategory: (id: string, input: string, groups: any[]) => void, input: string, data: any }) => {

  const StyledResultsContainer = styled.div`
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: start;
    align-items: flex-start;
    -ms-flex-pack: justify;
    justify-content: center;
    padding-bottom: 30px;
    
    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
  `;

  const StyledResultsLiActive = styled.div`
    cursor: pointer;
    background: #6c757d;
    color: #fff;
    padding: 5px 5px;
    border-radius: 5px;
    border: 1px solid #6c757d;
    
    &:hover {
      opacity: 0.8;
    }
    
    &:not(:last-child) {
      margin-right: 5px;
    }
  `;

  const StyledResultsLi = styled.div`
    cursor: pointer;
    color: #6c757d;
    background: #fff;
    border-radius: 5px;
    border: 1px solid #6c757d;
    padding: 5px 5px;
    
    &:hover {
      opacity: 0.8;
    }
    
    &:not(:last-child) {
      margin-right: 5px;
    }
  `;

  return (
    <div className="dealer-finder-groups">
      <StyledResultsContainer>
        {categories.map((category, index) => (
          data.groups && data.groups.indexOf(JSON.stringify(category.id)) > -1 ?
            <StyledResultsLiActive className="active activeGroup" onClick={() => searchCategory(JSON.stringify(category.id), input, data.groups)} key={index}>{category.title}</StyledResultsLiActive>
            :
            <StyledResultsLi onClick={() => searchCategory(JSON.stringify(category.id), input, data.groups)} key={index}>{category.title}</StyledResultsLi>
        ))}
      </StyledResultsContainer>
    </div>
  );
};
export default ResultsCategories;
